module.exports = "<modal show={{@show}} width={{modalWidth}} default-title={{title}}><div class=modal-body><h5 class=\"text-center text-primary\">{{infoText}}</h5></div><div class=modal-footer><button class=\"btn btn-primary btn-wide\" v-on=\"click: show=false\">确定</button></div></modal>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info-modal.vue
// module id = 75
// module chunks = 0